import { render, staticRenderFns } from "./lot-group-item-proposal-fields.vue?vue&type=template&id=6219c788&scoped=true&lang=pug"
import script from "./lot-group-item-proposal-fields.vue?vue&type=script&lang=js"
export * from "./lot-group-item-proposal-fields.vue?vue&type=script&lang=js"
import style0 from "./lot-group-item-proposal-fields.vue?vue&type=style&index=0&id=6219c788&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6219c788",
  null
  
)

export default component.exports